import React, { useEffect } from 'react';
import { ButtonClean, Checkbox, Fieldset } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { isPaidTier } from '../../../../utils';
import { useTierContext } from '../../hooks/useTierContext';
import { FormFields } from '../../providers/TierProvider/types';
import { fillCurrencyInputsWithFetchedPriceRates } from '../../providers/TierProvider/utils';
import { CurrenciesTable } from '../CurrenciesTable';
import { DefaultExchangeRate } from '../DefaultExchangeRate';
import * as S from './styled';
export const InternationalPricing = () => {
    const { form, tier, isLoading, updatedCurrencyConversion, priceRates } = useTierContext();
    // Fill all currency inputs on "Automatically convert international pricing" check
    useEffect(() => {
        if (!form.values.convertInternationalPricing)
            return;
        if (tier && !('pricesAutomaticallyConverted' in tier))
            return;
        // with initial values if editing tier, auto convert is initial value and user did not clicked "Update currency rates"
        if (tier &&
            isPaidTier(tier) &&
            form.initialValues.convertInternationalPricing === true &&
            !updatedCurrencyConversion &&
            form.values.price === form.initialValues.price) {
            return Object.keys(tier.variants.monthly.amounts).forEach((key) => {
                form.setFieldValue(`${[FormFields.currencies]}.${key}`, form.initialValues.currencies[key]);
            });
        }
        // with empty strings if there are no fetched auto rates (error)
        if (!priceRates) {
            return Object.keys(form.initialValues.currencies).forEach((key) => {
                form.setFieldValue(`${[FormFields.currencies]}.${key}`, '');
            });
        }
        // with fetched price rates
        fillCurrencyInputsWithFetchedPriceRates(form, priceRates);
    }, [form.values.convertInternationalPricing]);
    const getDisabled = () => {
        if (isLoading)
            return true;
        if (parseFloat(form.values.price) === 0)
            return true;
        if (tier &&
            form.initialValues.convertInternationalPricing === false &&
            tier.statistics.membersCount > 0)
            return true;
        return false;
    };
    if (tier && !isPaidTier(tier))
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Checkbox, { label: React.createElement(React.Fragment, null,
                        "Automatically convert tier price to all currencies (",
                        React.createElement(ButtonClean, { label: "learn more", href: "https://help.fourthwall.com/hc/en-us/articles/18300828600347-Multi-Currency-Settings", target: "_blank", withUnderline: true }),
                        ")"), disabled: getDisabled(), tooltip: React.createElement(React.Fragment, null,
                        React.createElement("p", null, "We\u2019ll convert your price to international currencies so that you earn about the same amount of profit (in USD) from international members. Once calculated, your membership price will stay fixed, so your earnings in USD will vary slightly month-to-month due to exchange rate fluctuations."),
                        tier &&
                            form.initialValues.convertInternationalPricing === false &&
                            tier.statistics.membersCount > 0 && (React.createElement("p", null,
                            React.createElement("br", null),
                            "Automatic currency conversion update is not available when there are active members."))), ...form.getFieldProps(FormFields.convertInternationalPricing) }))),
        React.createElement(DefaultExchangeRate, null),
        !form.values.convertInternationalPricing && (React.createElement(React.Fragment, null,
            React.createElement(CurrenciesTable, null),
            React.createElement(Fieldset.Row, { inner: true },
                React.createElement(S.CurrenciesManageLinkContainer, null,
                    React.createElement(ButtonClean, { appearance: "secondary", label: "Manage international currencies", to: routing.settings.checkout })))))));
};
